import { Loader2 } from "lucide-react";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useAdminSubmission } from "./use-admin-submission";
import { SubmissionDrawerContent } from "./submission-drawer-content";

// Drawer wrapper — handles loading + error states inside an open Sheet.
// Mirrors the sub-bucket-15 / sub-bucket-16 convention where the drawer
// mounts unconditionally and the inner component returns null when the
// trigger id is null (idle page mounts stay free).

export function SubmissionDrawer({
  submissionId,
  onClose,
}: {
  submissionId: string | null;
  onClose: () => void;
}) {
  const open = submissionId !== null;
  const query = useAdminSubmission(submissionId);

  return (
    <Sheet
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <SheetContent
        side="right"
        className="flex w-full flex-col gap-0 p-0 sm:max-w-[640px]"
      >
        {!submissionId ? null : query.isLoading ? (
          <div className="flex h-full items-center justify-center">
            <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
          </div>
        ) : query.isError ? (
          <div className="flex h-full flex-col items-center justify-center gap-2 px-6 text-center">
            <p className="text-sm font-medium text-foreground">
              Couldn&apos;t load this submission
            </p>
            <p className="text-xs text-muted-foreground">
              {query.error?.message ?? "Try refreshing the page."}
            </p>
          </div>
        ) : query.data ? (
          <SubmissionDrawerContent submission={query.data} />
        ) : null}
      </SheetContent>
    </Sheet>
  );
}
